<template>
  <!-- Claim Details -->
  <section>
    <section-header size="md" variants="dividing" class="mb-3">
      <heading :level="3" size="md" qaid="warranty-claim-details-header" v-html="bp('claimDetails')" />
    </section-header>

    <div class="grid-x grid-margin-x">
      <div class="cell medium-4">
        <form-group
          type="text"
          name="poNumber"
          qaid="warranty-claim-contact-po-number"
          :maxlength="30"
          :label="bp('poNumber')"
          :value="claimData.poNumber"
          @blur="updateVuex"
        />
        <form-group
          v-validate="'max:250'"
          type="textArea"
          name="notes"
          qaid="warranty-claim-contact-claim-notes"
          :help-text="`${bp('charactersRemaining')} ${noteCharactersRemaining}`"
          :label="bp('claimNotes')"
          :maxlength="maxNoteCharacters"
          :rows="4"
          :value="claimData.notes"
          @blur="updateVuex"
        />
        <label class="checkbox">
          <input
            type="checkbox"
            name="isWarrantyRepair"
            qaid="warranty-claim-non-warranty-claim"
            :checked="!claimData.isWarrantyRepair"
            @change="updateIsWarrantyRepair"
          />
          <span class="control-indicator"></span>
          {{ bp('nonWarrantyClaim') }}
        </label>
      </div>
    </div>
  </section>
</template>

<script>
import SectionHeader from '@/components/SectionHeader';
import FormGroup from '@/components/FormGroup';
import {mapMutations, mapActions} from 'vuex';
import Heading from '@/components/Heading';

export default {
  components: {SectionHeader, FormGroup, Heading},
  inject: ['$validator'],

  props: {
    baseProperties: {
      type: Array,
      required: true,
    },
    claimData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      maxNoteCharacters: 250,
    };
  },

  computed: {
    noteCharactersRemaining() {
      if (this.claimData.notes) {
        return this.maxNoteCharacters - this.claimData.notes.length;
      }

      return this.maxNoteCharacters;
    },
  },

  methods: {
    updateVuex(e) {
      this.updateProperty({
        propName: e.target.getAttribute('name'),
        value: e.target.value,
      });
    },

    updateIsWarrantyRepair(e) {
      this.updateProperty({
        propName: 'isWarrantyRepair',
        value: !e.target.checked,
      });
    },

    ...mapActions('warrantyClaims', ['updateProperty']),
    ...mapMutations('warrantyClaims', []),
  },
};
</script>
